import { lighten } from 'polished';

export const defaultColors = {
  /** Sort */
  primary1: '#000',
  /** Hvit */
  primary2: '#fff',
  /** Lakris */
  primary3: '#171719',
  primary3Dark: lighten(0.1, '#171719'),
  primary3Light: lighten(0.05, '#171719'),
  /** Rødvin */
  primary4: '#300A0F',
  /** Champagne */
  primary5: '#E7CFA7',
};
